module.exports = __webpack_public_path__ + "img/service.19f12a84.svg";